import { useEffect } from "react";

import { useNetworkState } from "@/lib/react-use/use-network-state";

import { notifyUserEventInfo } from "@/components/features/side-effect/notify-user-event-info/_hooks/use-toast";

/**
 * ユーザーのネットワーク状態を監視し下記の場合にユーザーへ通知する
 * - オフラインになった場合
 * - オフラインからオンラインに戻った場合
 */
export const useNetworkErrorHandler = () => {
	const { online, previous } = useNetworkState();

	useEffect(() => {
		if (!online) {
			notifyUserEventInfo({
				variant: "error",
				description: "現在オフラインになっています",
			});
		}
	}, [online]);

	useEffect(() => {
		if (online && previous === false) {
			notifyUserEventInfo({
				variant: "default",
				description: "オンラインに戻りました",
			});
		}
	}, [online, previous]);
};
